import '../Main.scss';

import * as React from 'react';
import { connect } from 'react-redux';

import {
    Container,
    Row,
    Col,
} from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faShieldCheck,
    faLock,
    faEye,
} from '@awesome.me/kit-8a0d2fd588/icons/modules/sharp/light';

import { ApplicationState } from '../../Store';
import { PortalTextBorrowerParameters } from '../../Models/Api/strongbox.financialportal';
import { GetPortalText } from '../../Store/PortalAssets';

type InjectedReduxState = {
    borrowerParametersText?: PortalTextBorrowerParameters;
};

type InjectedActionCreators = {};

type ImportSecurityComforterProps = {
};

type Props = InjectedReduxState & InjectedActionCreators & ImportSecurityComforterProps;

export const ImportSecurityComforterComponent: React.FC<Props> = (props): React.ReactElement => {
    const {
        borrowerParametersText,
    } = props;

    return (
        <Container 
            className={'security-comforter'}
            fluid
        >
            <Row>
                <Col className={'vcentered-content-col'}>
                    <FontAwesomeIcon 
                        icon={faShieldCheck} 
                    />
                    <span>{borrowerParametersText?.securityBulletSecure || ''}</span>
                </Col>
                <Col className={'vcentered-content-col'}>
                    <FontAwesomeIcon 
                        icon={faLock} 
                    />
                    <span>{borrowerParametersText?.securityBulletPrivate || ''}</span>
                </Col>
                <Col className={'vcentered-content-col'}>
                    <FontAwesomeIcon 
                        icon={faEye} 
                    />
                    <span>{borrowerParametersText?.securityBulletReadOnly || ''}</span>
                </Col>
            </Row>
        </Container>
    );
}

export const ImportSecurityComforter = connect<InjectedReduxState, InjectedActionCreators, ImportSecurityComforterProps, ApplicationState>(
    (appState: ApplicationState) => {
        const result: InjectedReduxState = {
            borrowerParametersText: GetPortalText<PortalTextBorrowerParameters>(appState, 'borrowerParameters'),
        };

        return result;
    }
)(ImportSecurityComforterComponent);
